module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-2-c689e6a5b87273310fd41c8d0371fa9d.jpg";